// extracted by mini-css-extract-plugin
export default {"AgentForm":"AgentForm_AgentForm__JNNeD","Form":"AgentForm_Form__qaqCr"};